import { Component, OnInit } from '@angular/core'
import { UsersService } from '../../services/users.service'
import { MessagesDelegate } from '../../services/messages-delegate.service'
import { EventsEmitterService } from '../../services/events-emitter.service'

import { User } from '../../models/user.model'
import { config } from '../../config/config'

@Component({
  selector: 'ld-users-list',
  template: require('./users-list.component.html'),
  styles: [require('./users-list.component.css')]
})
export class UsersListComponent implements OnInit {

  private users: User[] = []
  private filteredUsers: User[] = []
  private pages: number[] = []
  private pagesCount = 0
  private activePage = 0
  private showPagination = true

  constructor (
    private userService: UsersService,
    private messagesDelegate: MessagesDelegate,
    private eventsEmitter: EventsEmitterService
    ) {}

  async ngOnInit () {
    if (this.userService.currentUser.isAdmin()) this.eventsEmitter.emit('showAdminMenu', true)

    this.users = await this.userService.get()
        .catch(() => {
          this.messagesDelegate.add('APP.USERSLIST.ERROR')
          return []
        })

    this.showPage(0)
  }

  filter (value) {
    if (value.trim() === '') {
      this.showPagination = true
      this.showPage(0)
    } else {
      this.showPagination = false
      const search = new RegExp(this.removeAccent(value.trim()), 'gi')
      this.filteredUsers = this.users.filter(user => this.removeAccent(user.firstname).match(search) || this.removeAccent(user.lastname).match(search))
    }
  }

  removeAccent (str) {
    return str
      .toLowerCase()
      .replace(new RegExp(/[àáâãäå]/g),'a')
      .replace(new RegExp(/æ/g),'ae')
      .replace(new RegExp(/ç/g),'c')
      .replace(new RegExp(/[èéêë]/g),'e')
      .replace(new RegExp(/[ìíîï]/g),'i')
      .replace(new RegExp(/ñ/g),'n')
      .replace(new RegExp(/[òóôõö]/g),'o')
      .replace(new RegExp(/œ/g),'oe')
      .replace(new RegExp(/[ùúûü]/g),'u')
      .replace(new RegExp(/[ýÿ]/g),'y')
  }

  showPage (pageNumber: number) {
    // active page
    this.activePage = pageNumber

    // pages displayed in pagination menu
    this.pagesCount = Math.ceil(this.users.length / config.pagination.itemsPerPage)
    this.pages = Array(this.pagesCount)
      .fill(0)
      .map((x,i) => i)
      .filter((p) =>
        this.activePage < 2 && p < config.pagination.maxPagesDisplayed ||
          this.activePage > 0 && this.activePage < this.pagesCount - config.pagination.maxPagesDisplayed && p >= this.activePage - 2 && p <= this.activePage + 2 ||
        this.activePage >= this.pagesCount - config.pagination.maxPagesDisplayed && p >= this.pagesCount - config.pagination.maxPagesDisplayed
      )

    this.filteredUsers = this.users.slice(pageNumber * config.pagination.itemsPerPage, (pageNumber + 1) * config.pagination.itemsPerPage)
  }
}



// WEBPACK FOOTER //
// ../~/angular2-template-loader!./app/components/users-list/users-list.component.ts